/**
 * Скрипт на странице календаря матчей
 */
var matchesCalendar = {
    DATE: '',
    SEASON: 0,
    HOME_OR_VISITOR: 'all',
    TYPE: 'CALENDAR'
};

/**
 * Выполнить AJAX-запрос списка матчей по переменной matchesCalendar
 */
function doMatchesRequest()
{
    var $calendarHolder = $('.js-matches-calendar-wrapper');
    var $listHolder = $('.js-matches-list-wrapper.matches-by-list');
    var $loader = $('.js-loader-wrapper');
    var $statsHolder = $('.js-season-stats');
    $loader.addClass('loading');
    if (matchesCalendar.TYPE === 'CALENDAR')
    {
        $calendarHolder.empty();
    }
    else if (matchesCalendar.TYPE === 'LIST')
    {
        $listHolder.empty();
    }
    $statsHolder.empty();
    $.ajax('/ajax/matches.calendar.new.php', {
        method: 'GET',
        data: matchesCalendar,
        dataType: 'json'
    }).done(function (response) {
        if (matchesCalendar.TYPE === 'CALENDAR')
        {
            $calendarHolder.html(response.calendarHtml);
        }
        else if (matchesCalendar.TYPE === 'LIST')
        {
            $listHolder.html(response.calendarHtml);
            if ($('.games-item.future').length) {
                window.scrollTo(0, document.querySelectorAll('.games-item.future')[0].offsetTop - window.innerHeight / 2);
            }
        }
        $statsHolder.html(response.seasonStatsHtml);
        $loader.removeClass('loading');
    });
}

/**
 * Получить матчи за определенную дату
 *
 * @param {String} date
 * @param {Number} seasonId
 */
function GetCalendar(date, seasonId, type)
{
    if (typeof seasonId !== 'undefined') {
        if (matchesCalendar.SEASON !== seasonId) {
            $('.js-season-dropdown').trigger('season-changed', [seasonId]);
        }

        matchesCalendar.SEASON = seasonId;
    }

    matchesCalendar.DATE = date;
    matchesCalendar.TYPE = type;

    doMatchesRequest();
}

$(function () {
    // изменение сезона
    $('.js-season-dropdown').dropdown({
        select: function ($a) {
            var id = $a.attr('id').replace('a_', '');
            matchesCalendar.DATE = '';
            matchesCalendar.SEASON = id;

            doMatchesRequest();
        }
    });

    // изменение типа матча - "Дома / В гостях"
    var $typeFilter = $('.js-type-filter');

    $typeFilter.on('click', function () {
        var $btn = $(this);

        $btn.siblings().removeClass('is-active');
        $btn.toggleClass('is-active');

        var isActive = $btn.hasClass('is-active');

        if (isActive) {
            matchesCalendar.HOME_OR_VISITOR = $btn.data('type');
        } else {
            matchesCalendar.HOME_OR_VISITOR = 'all';
        }

        doMatchesRequest();
    });

});
